import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BriefSetsOrganisationTeam from "./BriefSetsOrganisationTeam";
import type BriefSetsStream from "./BriefSetsStream";
import type BriefSetsUser from "./BriefSetsUser";
import type Organisation from "./Organisation";
import type Stream from "./Stream";

@Model()
class BriefSet extends ApplicationRecord {
  static jsonapiType = "brief_sets";

  @Attr({ persist: false }) briefCount: number;

  @HasMany() briefSetsOrganisationTeams: BriefSetsOrganisationTeam[];

  @HasMany() briefSetsStreams: BriefSetsStream[];

  @HasMany() briefSetsUsers: BriefSetsUser[];

  @Attr() name: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamIds: number[];

  @HasMany() streams: Stream[];

  @Attr({ persist: false }) usersCount: number;
}

export default BriefSet;
